/* fk-pwa-install.js — Install banner for iPhone and Android */
(function(){
  'use strict';

  // Never show if already running as installed PWA
  if(window.matchMedia('(display-mode:standalone)').matches) return;
  if(window.navigator.standalone === true) return;

  // Never show if user dismissed within last 7 days
  var STORAGE_KEY = 'fk_pwa_dismissed';
  try {
    var dismissed = localStorage.getItem(STORAGE_KEY);
    if(dismissed && Date.now() - parseInt(dismissed,10) < 7*24*60*60*1000) return;
  } catch(e){}

  var ua = navigator.userAgent;
  var isIOS = /iphone|ipad|ipod/i.test(ua) && !window.MSStream;
  var isAndroid = /android/i.test(ua);
  var isChrome = /chrome/i.test(ua) && !/edge|opr\//i.test(ua);
  var isSafari = /safari/i.test(ua) && !/chrome|crios|fxios/i.test(ua);

  // iOS: only show in Safari (Chrome on iOS cannot install PWAs)
  if(isIOS && !isSafari) return;
  // Android: only show in Chrome
  if(isAndroid && !isChrome) return;
  // Show on neither? bail
  if(!isIOS && !isAndroid) return;

  var AR = (window.fkShop && window.fkShop.locale === 'ar');

  var TEXT = {
    title:   AR ? '\u062B\u0628\u062A \u062A\u0637\u0628\u064A\u0642 \u0632\u0648\u062F' : 'Install Zood',
    ios:     AR ? '\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u062B\u0645 \u00AB\u0623\u0636\u0641 \u0625\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629\u00BB' : 'Tap the <b>Share</b> button then <b>"Add to Home Screen"</b>',
    android: AR ? '\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u062B\u0644\u0627\u062B \u062B\u0645 \u00AB\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629\u00BB' : 'Tap the <b>3-dot menu</b> then <b>"Add to Home Screen"</b>',
    close:   AR ? '\u0644\u0627\u062D\u0642\u0627\u064B' : 'Maybe later'
  };

  // iOS share icon SVG
  var shareIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
  // Android 3-dot icon SVG
  var dotsIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>';
  // App icon — Zood logo (window.fkShop.logo is the store logo set in theme settings; CDN fallback is the same file)
  var appIcon = (window.fkShop && window.fkShop.logo) ? window.fkShop.logo : 'https://cdn.shopify.com/s/files/1/0804/0097/4076/files/Gemini_Generated_Image_j74zncj74zncj74z.png?width=200';

  function show(){
    var dir = AR ? 'rtl' : 'ltr';
    var instructionIcon = isIOS ? shareIcon : dotsIcon;
    var instructionText = isIOS ? TEXT.ios : TEXT.android;

    var banner = document.createElement('div');
    banner.id = 'fk-pwa-banner';
    banner.setAttribute('dir', dir);
    banner.innerHTML =
      '<div id="fk-pwa-banner-inner">'+
        '<img src="'+appIcon+'" width="48" height="48" alt="Zood" id="fk-pwa-icon">'+
        '<div id="fk-pwa-text">'+
          '<strong>'+TEXT.title+'</strong>'+
          '<span>'+instructionIcon+' '+instructionText+'</span>'+
        '</div>'+
        '<button id="fk-pwa-close" aria-label="Close">&#10005;</button>'+
      '</div>';

    // iOS: show arrow pointing down to the share bar at the bottom
    if(isIOS){
      banner.innerHTML += '<div id="fk-pwa-arrow"></div>';
    }

    document.body.appendChild(banner);

    // animate in
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        banner.classList.add('fk-pwa-visible');
      });
    });

    document.getElementById('fk-pwa-close').addEventListener('click', function(){
      dismiss(banner);
    });

    // also dismiss if user installs or navigates away
    window.addEventListener('appinstalled', function(){ dismiss(banner); });
  }

  function dismiss(banner){
    banner.classList.remove('fk-pwa-visible');
    setTimeout(function(){ if(banner.parentNode) banner.parentNode.removeChild(banner); }, 400);
    try{ localStorage.setItem(STORAGE_KEY, Date.now().toString()); }catch(e){}
  }

  // Android: wait for the beforeinstallprompt event to confirm installability
  if(isAndroid){
    var deferredPrompt = null;
    window.addEventListener('beforeinstallprompt', function(e){
      e.preventDefault();
      deferredPrompt = e;
      // Delay slightly so page loads first
      setTimeout(show, 2500);
    });
    // If no prompt fires within 4s (already dismissed by Chrome), do nothing
    return;
  }

  // iOS: just show after a short delay
  if(isIOS){
    setTimeout(show, 2500);
  }

}());
